export default __webpack_public_path__ + "static/media/logo-azadi.9cdf5bad.svg";